import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

// Import only the cleanup function
import { cleanupTrackingData } from "@/store/tracking-consent-store";

interface CookieStore {
  cookieAccepted: boolean;
  analyticsAccepted: boolean;
  toggleCookieAccepted: (newCookieAccepted: boolean) => void;
  toggleAnalyticsAccepted: (newAnalyticsAccepted: boolean) => void;
}

export const useCookieStore = create<CookieStore>()(
  persist(
    (set) => ({
      cookieAccepted: false,
      analyticsAccepted: false,

      // This function maintains backward compatibility with the original banner
      toggleCookieAccepted: (newCookieAccepted: boolean) => {
        if (!newCookieAccepted) {
          // If rejecting cookies, also disable analytics
          set({
            cookieAccepted: false,
            analyticsAccepted: false,
          });

          // Clean up tracking data when cookies are rejected
          if (typeof window !== "undefined") {
            cleanupTrackingData();
          }
        } else {
          // Update cookie acceptance
          set({ cookieAccepted: true });
        }
      },

      // This function allows for future UI enhancement
      toggleAnalyticsAccepted: (newAnalyticsAccepted: boolean) => {
        set({ analyticsAccepted: newAnalyticsAccepted });

        if (!newAnalyticsAccepted) {
          // Clean up tracking data when analytics are rejected
          if (typeof window !== "undefined") {
            cleanupTrackingData();
          }
        }
      },
    }),
    {
      name: "cookie-preferences",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
